import { render, staticRenderFns } from "./commonDetail.vue?vue&type=template&id=6ffad762&scoped=true&"
import script from "./commonDetail.vue?vue&type=script&lang=js&"
export * from "./commonDetail.vue?vue&type=script&lang=js&"
import style0 from "./commonDetail.vue?vue&type=style&index=0&id=6ffad762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffad762",
  null
  
)

export default component.exports